<template>
  <div class="state">
    <div class="main-width">
      <div class="state__wrapper">
        <div class="state__item" v-for="(state, stateIndex) in states" :key="stateIndex">
          <p class="state__title">{{state.title}}</p>
          <countTo class="state__num" :endVal="state.num" suffix="+"></countTo>
          <el-image class="state__icon" fit="contain" :src="state.icon"></el-image>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import countTo from "vue-count-to";

export default {
  components: {
    countTo,
  },
  data() {
    return {
      states: [
        {
          title: "商家信赖之选",
          num: 500,
          icon: require("@/assets/img/home/state_1.png"),
        },
        {
          title: "覆盖行业产品",
          num: 20000,
          icon: require("@/assets/img/home/state_2.png"),
        },
        {
          title: "邮轮资讯报道",
          num: 10000,
          icon: require("@/assets/img/home/state_3.png"),
        },
        {
          title: "年成交量",
          num: 15000,
          icon: require("@/assets/img/home/state_4.png"),
        },
      ],
    };
  },
};
</script>
<style lang="scss" scoped>

.state {
  background: #fff;
  padding: 95px 0 55px;
  &__wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    // width: 200px;
  }
  &__item {
    width: 280px;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  &__title {
    color: #495057;
    font-size: 20px;
    margin-bottom: 6px;
  }
  &__num {
    @font-face {
      font-family: "impact";
      src: url("/impact/impact.ttf") format("truetype"); /* Safari, Android, iOS */
    }
    font-family: 'impact';
    color: #495057;
    font-size: 60px;
    margin-bottom: 30px;
    font-weight: 600;
  }
  &__icon {
    width: 143;
    height: 130px;
  }
}

</style>